import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatTableDataSource, MatSort, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-hotel',
  templateUrl: './hotel.component.html',
  styleUrls: ['./hotel.component.css']
})
export class HotelComponent implements OnInit {

  countryList = [];
  city = [];
  cityList = [];

  hotel_types = [{ 'value': 'one', 'type_name_ar': 'نجمة', 'type_name_en': 'One Star' },
  { 'value': 'two', 'type_name_ar': 'نجمتين', 'type_name_en': 'Two Stars' },
  { 'value': 'three', 'type_name_ar': 'ثلاث نجوم', 'type_name_en': 'Three Stars' },
  { 'value': 'four', 'type_name_ar': 'أربع نجوم', 'type_name_en': 'Four Stars' },
  { 'value': 'five', 'type_name_ar': 'خمس نجوم', 'type_name_en': 'Five Stars' },
  { 'value': 'tourism', 'type_name_ar': 'سياحي', 'type_name_en': 'Tourism' },
  { 'value': 'none', 'type_name_ar': 'غير محدد', 'type_name_en': 'None' }];

  model = {
    'table_name': 'hotel', 'hotel_id': '0', 'hotel_name': '', 'hotel_name_en': '', 'city_id': '',
    'country_id': '', 'housing_type': '', 'hotel_type': '', 'address': '', 'hotel_tel': '',
    'hotel_email': '', 'hotel_site': '', 'responsible': '', 'responsible_phone': '', 'comment': ''
  };

  Success_Msg; Error_Msg; Hotel_Name_Msg;

  constructor(private utils: Utils, public applicationConstants: ApplicationConstants,
    private queryList: QueryList, private dialogRef: MatDialogRef<HotelComponent>,
    @Inject(MAT_DIALOG_DATA) public dialog_data: any, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);


    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

    translate.get('Hotel_Name_Msg').subscribe((res: string) => {
      this.Hotel_Name_Msg = res;
    });

  }

  ngOnInit() {
    if (this.dialog_data != null)
      this.model = this.dialog_data;

    let query = this.queryList.all_country;
    let obj2 = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj2)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.countryList = data.data['list'];
      });

    query = this.queryList.all_city;
    obj2 = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj2)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.city = data.data['list'];
        if (this.dialog_data != null)
          this.getCity();
      });
  }

  getCity() {
    this.cityList = [];
    this.city.forEach(element => {
      if (element.country_id == this.model['country_id'])
        this.cityList.push(element);
    });
  }

  add() {
    if (this.model['hotel_name'] != '') {
      let values = [];
      values.push(this.model);

      let obj;
      if (this.model['hotel_id'] == '0')
        obj = { cmd: 'add', values: values };
      else {
        let where = [{ 'hotel_id': this.model['hotel_id'] }];
        obj = { cmd: 'update', values: values, where: where };
      }
      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          if (data.status['type'] == 'success') {
            alert(this.Success_Msg);
            this.dialog_data = {
              'status': data.status['type']
            };
            this.dialogRef.close(this.dialog_data);
          }
          else {
            alert(this.Error_Msg);
          }
        });
    }
    else if (this.model['hotel_name'] == '') {
      alert(this.Hotel_Name_Msg);
    }
  }

  cancel() {
    this.dialogRef.close(this.dialog_data);
  }

}
